<template>
  <div :class="[list_bg, 'nzmWelfareCenter']" v-if="data_list && data_list.length > 0">
    <div class="welfare_block">
      <template v-if="list_style == 'l01'">
        <ul class="ul1">
          <li v-for="(row_item, index) in data_list" :key="index">
            <WelfareItem
              :info="row_item"
              :click_button="row_item.click_button"
              :click_img="row_item.click_img"
            />
          </li>
        </ul>
      </template>
      <template v-if="list_style == 'l02'">
        <div class="swiper-wrap">
          <van-swipe class="my-swipe" :autoplay="3000">
            <van-swipe-item v-for="(row_item, index) in swipe_list" :key="index">
              <WelfareItem
                :info="row_item"
                :click_button="row_item.click_button"
                :click_img="row_item.click_img"
                className="swiper-style"
                :showSquaImg="true"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="random-wrap">
          <ul>
            <li v-for="(row_item, index) in getDataList(data_list, 6)" :key="index">
              <WelfareItem
                :info="row_item"
                :click_button="row_item.click_button"
                :click_img="row_item.click_img"
                className="random-style"
                :showSquaImg="true"
              />
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import click_handler from '../../tools/mgtv/click';
import { openLink } from '../../tools/mgtv/link';
import { getJSON, getJSONP } from '../../api/myaxios';
import { toRem } from '../../tools/tpl';
import Title from './Title.vue';
import WelfareItem from './NzmWelfareCenter/WelfareItem.vue';
import { group_by_size } from '../../tools/group';
import { onUseInfoLoad } from '../../tools/onUseInfoLoad';
import { urlToWebp } from '../../tools/tpl';
import { jumpToMoreBenefit } from './NzmBenefit/benefitApi';
import { GET_GIFT } from '../../constant/eventbus';
import cloneDeep from 'lodash/cloneDeep';

import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);

const JINGXUAN_TYPE = '0'; // 0是精选

export default {
  name: 'NzmBenefitRecommend',
  components: { Title, WelfareItem },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          act_name: 'act_name',
          act_name_chn: '会员福利社',
          wrap_style: {
            paddingTop: '0px'
          },
          title: {
            show: false
          },
          config: {}
        };
      }
    }
  },
  data: function() {
    return {
      data_list: [],
      swipe_list: [],
    };
  },
  computed: {
    act_name() {
      return "m_202112_qitafuli";
    },
    list_bg() {
      return this.info.config && this.info.config.list_bg;
    },
    list_style() {
      return (this.info.config && this.info.config.list_style) || 'l01';
    }
  },
  methods: {
    get_detail: function(type = JINGXUAN_TYPE) {
      const params = {
        act_name: this.act_name,
        top_recommend: 1,
        type:0,
        invoker: window.gact.invoker,
        ticket: window.$bus.user.ticket,
        f_release:window.gact.f_release
      };
      params.type = type;
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/vipbenefits/m/list",
        params,
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          const data_list = res.data.list;
          data_list.forEach(item => {
            item.head_img = urlToWebp(item.head_img);
            item.click_button = () => {
              this.click_button(item);
            };
            item.click_img = () => {
              this.click_img(item);
            };
          });
          if (this.list_style === 'l01') {
            this.swipe_list = data_list.filter(item => item.pick_pos === 5).slice(0, this.info.config.max_num);
            this.data_list = data_list.filter(item => item.pick_pos === 6).slice(0, this.info.config.max_num);
          } else {
            this.swipe_list = data_list.filter(item => item.pick_pos === 5);
            this.data_list = data_list.filter(item => item.pick_pos === 6);
          }
        }
      });
    },
    getDataList(data, type) {
      // type == 5 返回轮播的数据  type = 6  返回随机数据
      let arr = cloneDeep(data);
      arr = arr.filter(item => item.pick_pos === type) || [];
      if (type === 5) {
        return arr.slice(0, 6); // 最多取6项
      } else if (type === 6) {
        arr = arr.sort(function() {
          return Math.random() - 0.5;
        });
        return arr.slice(0, 2);
      }
    },
    click_button: function(item) {
      if (item.out_stock === 1) {
        return;
      }
      const need_vip_level = item.received === 1 ? 0 : item.growth_level; //如果已领取，则不检查等级，否则检查等级
      click_handler(
        `领取福利-${item.award_name}`,
        () => {
          window.$bus.$emit(GET_GIFT, { awardInfo: item, act_name: this.act_name });
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: need_vip_level
        }
      );
    },
    click_img: function(item) {
      jumpToMoreBenefit(item, this.act_name);
    }
  },
  created() {
    onUseInfoLoad(() => {
      this.get_detail();
    }, false);
  }
};
</script>

<style lang="stylus" scoped>

.nzmWelfareCenter
  position relative
  width 7.5rem
  &.m02
    .welfareItem
      background-color: #2B2E33;
      border-radius: 0.16rem;
      overflow: hidden;
      >>>.title
        color: #ECECEC;
      >>>.sub_title
        color: #6A6A6A;
      >>>.button
        box-shadow: none;
  .welfare_block
    position relative
    margin-top .3rem
    .ul1
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 0.3rem;
      li
        width: 3.38rem
        margin-bottom: 0.2rem
    .row
      display flex
      padding 0 .3rem
      justify-content space-between
      margin-top .2rem
    .swiper-wrap
      background: #F6F6F6
      width: 3.08rem
      height: 3.78rem
      border-radius: 0.16rem;
      overflow: hidden;
      margin-left: 0.3rem
      >>>.van-swipe__indicator
        background: #000;
      >>>.van-swipe__indicator--active
        opacity : 1;
        background: #FF5F00;
      .my-swipe
        width: 100%
        height: 100%
        background: linear-gradient(180deg, #FFE5E6 0%, rgba(255, 255, 255, 0) 30%);
      .my-swipe .van-swipe-item
        font-size: 20px;
        text-align: center;
        width: 3.08rem;
        .img-wrap
          width: 1.6rem
          height: 1.6rem
          margin: 0.2rem auto 0.16rem
          img
            width: 100%
    .random-wrap
      width: 3.68rem;
      position: absolute;
      right: 0.3rem;
      top: 0;
      li
        height: 1.82rem;
        background: #F6F6F6;
        border-radius: 0.16rem;
        margin-bottom:0.14rem;
        overflow hidden;
</style>
